import { ApplicationRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class NotificationService {
    constructor(appRef) {
        this.appRef = appRef;
        this._notification = new BehaviorSubject(null);
        this.notification$ = this._notification.asObservable();
    }
    notify(message) {
        this._notification.next({ message, shouldShow: true });
        this.appRef.tick();
        setTimeout(() => {
            this._notification.next({ message, shouldShow: false });
            this.appRef.tick();
        }, 3000);
    }
}
NotificationService.ngInjectableDef = i0.defineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.inject(i0.ApplicationRef)); }, token: NotificationService, providedIn: "root" });
